<template lang="pug">
    dynamic-filter-picker(
        title="Custom Filter"
    )
        div(slot="body")
            till-dynamic-filter
</template>

<script>
import dynamicFilterPicker from '@js/components/filter/dynamic-filter-picker';
import tillDynamicFilter from './till-dynamic-filter';

export default {
    components: {
        tillDynamicFilter,
        dynamicFilterPicker,
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/till-filter/till-filter.vue